import React from "react"

const SharedQueryDevTools =
  process.env.REACT_APP_release === "true"
    ? () => null
    : (() => {
        const DevTools = React.lazy(
          () =>
            import("@myvp/shared/src/dev-tools/internal-shared-query-dev-tools")
        )
        return () => (
          <React.Suspense>
            <DevTools />
          </React.Suspense>
        )
      })()

export default SharedQueryDevTools
